<template>
  <v-dialog v-model="isOpen" max-width="500" persistent>
    <v-card class="modal-card">
      <h2
        class="modal-title"
        :class="{
          'secondary--text': body.isError,
          'text-center': body.centerTitle
        }"
      >
        {{ body.title }}
      </h2>
      <p class="modal-content" v-html="body.text"></p>
      <p v-if="body.textSecondary" class="modal-content">
        {{ body.textSecondary }}
        <v-progress-circular
          v-if="body.loading && body.hasNextButton"
          indeterminate
          color="primary"
          size="15"
          width="2"
        />
      </p>
      <img
        class="mb-4"
        v-if="body.imgSource && body.imgAlt"
        :src="require(`@/static/${body.imgSource}`)"
        :alt="body.imgAlt"
      />
      <div class="d-flex">
        <v-btn
          color="primary"
          v-if="body.hasCancelButton"
          outlined
          class="mx-2"
          min-width="188"
          @click="$emit('closeDialog', false)"
        >
          {{ $t("message.common.cancel") }}
        </v-btn>
        <v-btn
          color="error"
          v-if="body.hasDeleteButton"
          class="mx-2"
          min-width="188"
          @click="$emit('delete', { type: body.type, id: body.type_id })"
        >
          {{ $t("message.common.delete") }}
        </v-btn>

        <v-btn
          class="mx-2"
          v-if="body.hasNextButton"
          color="primary"
          min-width="188"
          @click="$router.push({ name: 'wizard-step-3' })"
        >
          {{ $t("message.common.next") }}
        </v-btn>
        <v-btn
          class="mx-2"
          v-if="!body.hasDeleteButton && !body.hasNextButton"
          :color="body.isError ? 'secondary' : 'primary'"
          :loading="body.loading"
          min-width="188"
          @click="
            $emit(
              body.hasAddAccountButton ? 'addAccount' : 'closeDialog',
              false
            )
          "
        >
          {{ $t("message.common.ok") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ListingsConfigurationConfirmationDialog",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    body: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: $spacing * 3;
}

.modal-title {
  @include font-size(16px);
  font-family: $font-family-base;
  font-weight: $font-weight-bold;
  text-align: center;
  margin-bottom: $spacing * 2;
  margin-top: $spacing;
  line-height: 25px;
}

.modal-content {
  @include font-size(14px);
  width: 100%;
  max-width: 350px;
  margin-bottom: $spacing * 4;
  text-align: center;
}
</style>
